var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-accordion',{attrs:{"name":"transaction-defaults","section":"Transaction Defaults","url":_vm.url,"method":"patch","closed":_vm.closed}},[_c('percent-split',{attrs:{"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }